import { render, staticRenderFns } from "./BajasComercialesBase.vue?vue&type=template&id=38374362&"
import script from "./BajasComercialesBase.vue?vue&type=script&lang=ts&"
export * from "./BajasComercialesBase.vue?vue&type=script&lang=ts&"
import style0 from "./BajasComercialesBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('38374362', component.options)
    } else {
      api.reload('38374362', component.options)
    }
    module.hot.accept("./BajasComercialesBase.vue?vue&type=template&id=38374362&", function () {
      api.rerender('38374362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasComerciales/BajasComercialesBase.vue"
export default component.exports